module.exports = __webpack_public_path__ + "static/media/and_scr_landscape.6e198a2a.png";